<template>
    <div id="listCall">
        <template v-if="cantAccessPageCall === true">
            <div class="container-fluid xyz">
                <div :class="'page-header-top-container'+titleMargin">
                    <div class="page-name color-71aa3f">{{callPageData.pageTitle}}</div>
                    <template  v-for="(permission, index) in permissionsCall">
                        <button title="Add" v-if="permission.name == 'can_add_new_calls'" class="btn general-button btn-primary icon-btn" id="submit" name="submit" v-on:click.prevent="addCall"><i class="fa fa-plus" aria-hidden="true"></i></button>

                        <button title="Import" v-if="permission.name == 'can_import_calls_data' && callPageData.cus_id == 0" type="button" class="btn general-button btn-primary icon-btn" data-toggle="modal" data-target="#callImportModal">
                            <i class="fa fa-cloud-upload" aria-hidden="true"></i>
                        </button>
                        <button title="Export" v-if="permission.name == 'can_export_calls_data'" type="button" id='exportCall' class="btn general-button btn-primary icon-btn" 
                                v-on:click="exportCalls($event)">
                            <i class="fa fa-cloud-download" aria-hidden="true"></i>
                        </button>
                    </template>
                    <div class="btn-group pull-right ml-2">
                        <button type="button" class="btn_all_call btn general-button btn-primary" v-on:click="allClickCall()">All</button>
                        <button type="button" class="btn_my_call btn general-button btn-secondary" v-on:click="myClickCall()">My Self</button>
                    </div>
                    <div class="btn-group pull-right">
                        <button type="button" class="btn_normal_call btn general-button btn-primary" v-on:click="normalClickCall()">Normal</button>
                        <button type="button" class="btn_dunning_call btn general-button btn-secondary" v-on:click="dunningClickCall()">Over Due</button>
                    </div>
                </div>
                <div class="admin-page-content">
                    <div class="app-filter-good-table-container">
                        <vue-good-table class="callsTable"
                                        ref="listCallTable"
                                        mode="remote"
                                        title="Calls"
                                        @on-page-change="onPageChangeCall"
                                        @on-selected-rows-change="selectionChangedCall"
                                        @on-column-filter="onColumnFilterCall"
                                        @on-per-page-change="onPerPageChangeCall"
                                        @on-sort-change="onSortChangeCall"
                                        :totalRows="totalRecordsCall"
                                        :columns="columnsCall"
                                        :rows="rowsCall"
                                        :pagination-options="{
                                        enabled: true,
                                        mode: 'pages',
                                        pageLabel: 'Page',
                                        position: 'bottom',
                                        perPage: serverParamsCall.perPage,
                                        setCurrentPage: serverParamsCall.setCurrentPage,
                                        perPageDropdown: serverParamsCall.perPageDropdown,
                                        dropdownAllowAll: false,
                                        }"
                                        :select-options="{
                                        enabled: true,
                                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                        selectionInfoClass: 'custom-class',
                                        selectionText: 'rows selected',
                                        clearSelectionText: 'clear',
                                        }"

                                        :search-options="{
                                        enabled: false,
                                        }"
                                        >
                                        <template slot="pagination-bottom" slot-scope="props">
                                <div class="vgt-wrap__footer crm" v-if="totalRecordsCall > 0">
                                    <div  class="row">
                                        <div class="col-sm-12 col-md-2 PerPage">
                                            <v-select title="Select Per Page"
                                                      v-model="serverParamsCall.perPage"
                                                      @change="changedValueCall"
                                                      @input="changedValueCallCustomPerPageCall()"
                                                      name="customPerPage"
                                                      id="customPerPage"
                                                      label="text"
                                                      :clearable="false"
                                                      :searchable="false"
                                                      :filterable="false"
                                                      :options="serverParamsCall.perPageDropdown"
                                                      placeholder="Select Per Page">
                                            </v-select>
                                        </div>
                                        <div class="mt-2 col-sm-12 col-md-2 RowsDisplay">
                                            <p class="pageRowCount">{{paginationDisplayRowsCall}} of {{totalRecordsCall}}</p>
                                        </div>
                                        <div class="col-sm-12 col-md-6 Pagination">
                                            <ul class="pagination">
                                                <li class="page-item FirstPage" title="First Page">
                                                    <template v-if="Number(serverParamsCall.page) == 1">
                                                        <a class="page-link" href="javascript:void(0)">1</a>
                                                    </template>
                                                    <template v-else>
                                                        <a v-on:click="onPerticularPageClickCall(1)" class="page-link" href="javascript:void(0)">1</a>
                                                    </template>
                                                </li>
                                                <li class="page-item PreviousPage" title="Previous Page">
                                                    <template v-if="Number(serverParamsCall.page) == 1">
                                                        <a class="page-link" href="javascript:void(0)" tabindex="-1"><i class="fa fa-angle-left"></i></a>
                                                    </template>
                                                    <template v-else>
                                                        <a class="page-link" href="javascript:void(0)" tabindex="-1" v-on:click="onPerticularPageClickCall(Number(serverParamsCall.page)-1)" ><i class="fa fa-angle-left"></i></a>
                                                    </template>
                                                </li>
                                                <!--New Implementation-->
                                                <template v-if="pageNumberListCall() < displayPageCall">
                                                    <template v-for="(n, index) in pageNumberListCall()">
                                                        <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParamsCall.page)">
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                        <li :title="'Page ' +n" v-on:click="onPerticularPageClickCall(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <!--End New Implementation-->
                                                    <template v-if="Number(serverParamsCall.page) <= pageCompareCall">
                                                        <template v-for="(n, index) in displayPageCall">
                                                            <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParamsCall.page)">
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                            <li :title="'Page ' +n" v-on:click="onPerticularPageClickCall(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                        </template>
                                                    </template>
                                                    <template v-else-if="Number(serverParamsCall.page) >= (pageNumberListCall() - (pageCompareCall-1))">
                                                        <template v-for="(n, index) in pageNumberListCall()">
                                                            <template v-if="n > (pageNumberListCall() - displayPageCall)">
                                                                <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParamsCall.page)">
                                                                    <a class="page-link" href="javascript:void(0)">
                                                                        {{n}}
                                                                    </a>
                                                                </li>
                                                                <li :title="'Page ' +n" v-on:click="onPerticularPageClickCall(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                    <a class="page-link" href="javascript:void(0)">
                                                                        {{n}}
                                                                    </a>
                                                                </li>
                                                            </template>
                                                        </template>
                                                    </template>
                                                    <template v-else>
                                                        <template v-for="(n, index) in pageNumberListCall()" v-if="(n >= (Number(serverParamsCall.page) - (pageCompareCall -1))) && (n <= (Number(serverParamsCall.page) + (pageCompareCall -1)))">
                                                            <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParamsCall.page)">
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                            <li :title="'Page ' +n" v-on:click="onPerticularPageClickCall(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                        </template>
                                                    </template>
                                                </template>
                                                <li class="page-item NextPage" title="Next Page">
                                                    <template v-if="Number(serverParamsCall.page) == pageNumberListCall()">
                                                        <a class="page-link" href="javascript:void(0)"><i class="fa fa-angle-right"></i></a>
                                                    </template>
                                                    <template v-else>
                                                        <a class="page-link" href="javascript:void(0)" v-on:click="onPerticularPageClickCall(Number(serverParamsCall.page)+1)"><i class="fa fa-angle-right"></i></a>
                                                    </template>
                                                </li>
                                                <li class="page-item LastPage" title="Last Page">
                                                    <template v-if="Number(serverParamsCall.page) == pageNumberListCall()">
                                                        <a class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListCall()}}</a>
                                                    </template>
                                                    <template v-else>
                                                        <a v-on:click="onPerticularPageClickCall(pageNumberListCall())" class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListCall()}}</a>
                                                    </template>
                                                </li>
                                            </ul>
                                        </div>                                
                                        <div class="mt-2 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                            <p class="pageJumpLabel">Page : </p>
                                        </div>
                                        <div class="mt-1 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                            <input @keyup.enter="jumpToPageInCall" v-model="jumpToPageCall" type="text" class="form-control form-control-sm" name="jumpToPageCall" id="jumpToPageCall" placeholder="Page">
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template slot="table-row" slot-scope="props" v-for="(row,key) in rowsCall">
                                <div :key="key" data-toggle="tooltip" data-placement="bottom" :title="'Additional Comments : ' + props.row.full_notes">
                                    <div v-if="props.column.field == 'action'">
                                        <!--class="btn btn-xs general-button btn-primary"-->
                                        <template v-if="permission.name == 'can_add_new_calls'" v-for="(permission, index) in permissionsCall">
                                            <router-link title='Edit call' v-if="props.row.created_by == loginIDCall && props.row.call_type != 'Dunning Notice'" class="btn edit-btn-vvg waves-effect" v-bind:to="{name: 'EditCall',params:{id:props.row.id,from:callPageData.cus_id}}"><i class="fa fa-pencil-square-o"></i></router-link>
                                        </template>
                                        <template v-if="permission.name == 'can_see_calls_view'" v-for="(permission, index) in permissionsCall">
                                            <router-link title='View call details' class="btn edit-btn-vvg" v-bind:to="{name: 'CallsView',params:{id:props.row.id,from:callPageData.cus_id}}"><i class="fa fa-eye"></i></router-link>
                                        </template>
                                    </div>
                                    <div v-else-if="props.column.field == 'notes'">
                                        <span v-html="props.row.notes"></span>
                                    </div>
                                    <div v-else>
                                        {{props.formattedRow[props.column.field]}}
                                    </div>
                                </div>
                            </template>
                            <div slot="selected-row-actions">
                                <template v-if="permission.name == 'can_add_new_calls'" v-for="(permission, index) in permissionsCall">
                                    <button title='Delete call' v-on:click.prevent="onDeleteClickCall" class="btn general-button btn-success">Delete</button>
                                </template>    
                            </div>

                        </vue-good-table>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="callImportModal" tabindex="-1" role="dialog">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title" id="defaultModalLabel">Import Calls From Excel</h4>
                        </div>
                        <form class="form-inline" id="importTasksform" enctype="multipart/form-data">
                            <div class="modal-body">
                                Select Excel File to Import Calls
                                <label class="myLabel btn general-button btn-info m-r-20">
                                    <input type="file" name="excl_file" accept=".xlsx,.xls" id="upload" ref="filesCall" v-on:change="handleFilesUploadCall()"/>
                                    <span>Select File ...</span>
                                </label>
                                <div class="form-group">
                                    <label id="errorMsg" class="error"></label><br>
                                </div>
                                <a id ="demourl" href="demoUrl" target="_blank" class="btn general-button btn-info mt-2">
                                    Download Demo
                                </a>
                            </div>
                            <div class="modal-footer">
                                <button type="button" v-on:click="importCalls($event);" class="btn general-button btn-success">Import</button>
                                <button type="button" class="btn general-button btn-danger" data-dismiss="modal">Close</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="CallsExportModel" tabindex="-1" role="dialog">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title" id="defaultModalLabel">Import Calls From Excel</h4>
                        </div>
                        <div class="modal-body">
                            Call's Exported File is ready to download Please click <a type="button" id="downloadButton" target="_blank" href = "" ><label style="cursor: pointer;" class="font-bold col-pink">DOWNLOAD</label></a> to download the file.
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn general-button btn-danger waves-effect" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="admin-page-content">
                <div class="col-md-12 error-detail-main forms-container">
                    <div class="error-template">
                        <h1>Oops!</h1>
                        <h2>403</h2>
                        <div class="error-details">Sorry!, You don't have permission to access this page.</div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>


    // import { headers } from "../config";
    import {listcallUrl, configs} from '../../config';
    import SessioMixin from '../../mixins/sessionmixin';
    import Vue from 'vue';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    import {listCallTable} from '../../config';
    import EventBus from '../event-bus';
    import swal from 'sweetalert2/dist/sweetalert2.js';
    const Swal = require('sweetalert2');

    Vue.use(VueGoodTable);

    export default {
        name: "listCall",
        mixins: [SessioMixin],
        props: {
            callPageData: '',
        },
        data: () => ({
                titleMargin: '',
                displayPageCall: 7,
                pageCompareCall: 0,
                paginationDisplayRowsCall: '',
                jumpToPageCall: 0,

                loginIDCall: 0,
                messageCall: 'all',
                callType: 'normal',
                permissionsCall: [],
                cantAccessPageCall: true,
                // filteredFlag: false,
                exportFilteredFlagCall: false,
                firstLoadCall: 0,
                filesCall: [],
                columnsCall: [

                    // {
                    //     label: 'Collector',
                    //     field: 'user_first_name',
                    //     filterable: true,
                    //     hidden: false,
                    //     sortable: false,
                    //     filterOptions: {
                    //         enabled: true, // enable filter for this column
                    //         placeholder: "Collector", // placeholder for filter input
                    //         filterValue: '', // initial populated value for this filter
                    //         trigger: "enter" //only trigger on enter not on keyup
                    //     }
                    // },
                    {
                        label: 'CusId',
                        field: 'cusid',
                        filterable: true,
                        hidden: false,
                        sortable: false,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "CusId", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Customer Name',
                        field: 'customer_first_name',
                        filterable: true,
                        hidden: false,
                        sortable: false,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Customer Name", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Call Date',
                        field: 'call_date_time',
                        filterable: true,
                        sortable: false,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "From | To", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Subject',
                        field: 'subject',
                        filterable: true,
                        sortable: false,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Subject", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Additional Comments',
                        field: 'notes',
                        filterable: true,
                        sortable: false,
                        html: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Additional Comments", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Created By',
                        field: 'created_first_name',
                        filterable: true,
                        sortable: false,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Created By", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },

                    /*{
                     label: 'Additional Comments',
                     field: 'notes',
                     filterable: true,
                     filterOptions: {
                     enabled: true, // enable filter for this column
                     placeholder: "Additional Comments", // placeholder for filter input
                     filterValue: '', // initial populated value for this filter
                     trigger: "enter" //only trigger on enter not on keyup
                     }
                     },*/
                    /*{
                     label: 'Direction',
                     field: 'direction',
                     filterable: true,
                     sortable: false,
                     filterOptions: {
                     enabled: true, // enable filter for this column
                     placeholder: "Select Direction", // placeholder for filter input
                     filterDropdownItems: ['Incoming', 'Outgoing'], // dropdown (with selected values) instead of text input
                     filterValue: '', // initial populated value for this filter
                     trigger: "enter" //only trigger on enter not on keyup
                     }
                     },
                     {
                     label: 'Contact Name',
                     field: 'contact_first_name',
                     filterable: true,
                     sortable: false,
                     filterOptions: {
                     enabled: true, // enable filter for this column
                     placeholder: "Contact Name", // placeholder for filter input
                     filterValue: '', // initial populated value for this filter
                     trigger: "enter" //only trigger on enter not on keyup
                     }
                     },*/
                    {
                        label: 'Priority',
                        field: 'priority',
                        filterable: true,
                        sortable: false,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Select Priority", // placeholder for filter input
                            filterDropdownItems: ['Low', 'Medium', 'High'], // dropdown (with selected values) instead of text input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Type',
                        field: 'call_type',
                        filterable: true,
                        sortable: false,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Select Type", // placeholder for filter input
                            filterDropdownItems: ['Call', 'Over Due', 'E-Mail'], // dropdown (with selected values) instead of text input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Actions',
                        field: 'action',
                        html: true,
                        sortable: false,
                        thClass: 'disable-sorting',
                        width: '106px',
                    }
                ],
                rowsCall: [],
                totalRecordsCall: 0,
                serverParamsCall: {
                    columnFilters: {},
                    sort: {
                        field: 'call_date_time',
                        type: 'desc',
                    }/*[
                     {
                     field: 'priority',
                     type: 'asc',
                     },
                     {
                     field: 'call_date_time',
                     type: 'desc',
                     }
                     ]*/,

                    page: 1,
                    perPage: 25,
                    setCurrentPage: 1,
                    perPageDropdown: [],
                },
            }),
        // computed: {
        //
        //         selectedRows:[]
        //
        // }
        mounted: function () {
            var app = this;
            if (app.callPageData.is_part == 1) {
                app.titleMargin = " pt-0";
            }
            if (this.callPageData.cus_id > 0) {
                this.loadFilters('menucallscustomer', this.columnsCall, this.serverParamsCall, 'callsTable');
            } else {
                this.loadFilters('menucalls', this.columnsCall, this.serverParamsCall, 'callsTable');
            }
            /*console.log(JSON.stringify(this.serverParamsCall));
             app.$nextTick(function () {
             console.log("1st In Next Tick");
             console.log(JSON.stringify(this.serverParamsCall));
             });*/
            var initial = process.env.ROOT_API;
            initial = initial.replace('/v1', '');
            $("#demourl").attr("href", initial + '/demo/Calls.xlsx');
            app.showLoader();
            var userObj = localStorage.getItem('user_obj');
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                this.loginIDCall = userJson.id;
                EventBus.$emit("logged-in", false, userJson["first_name"], userJson["last_name"], userJson["email"]);
            }
            this.jumpToPageCall = this.serverParamsCall.page;
            this.pageCompareCall = Math.ceil(this.displayPageCall / 2);
            $("#jumpToPageCall").on('keyup', function (e) {
                if (e.keyCode === 13) {  //checks whether the pressed key is "Enter"
                    app.jumpToInputPageCall(app.jumpToPageCall);
                }
            });
            this.serverParamsCall.perPage = this.callPageData.perPage;
            for (var i = this.callPageData.perPage; i < 100; ) {
                this.serverParamsCall.perPageDropdown.push(i);
                if (this.callPageData.perPage < 5) {
                    i = i * 5;
                } else {
                    i = i * 2;
                }
            }
            this.serverParamsCall.perPageDropdown.push(100);
            this.serverParamsCall.perPageDropdown.push(200);
            this.serverParamsCall.perPageDropdown.push(500);
            this.loadCalls();
            /*app.$nextTick(function () {
             console.log("In Next Tick");
             console.log(JSON.stringify(this.serverParamsCall));
             });*/
        },
        beforeMount: function () {
            var app = this;
            var check = window.localStorage.getItem('api_token');

            if (check != null) {
                app.getPermissionsCall();
            }
            if (app.callPageData.cus_id > 0) {
                app.columnsCall['1'].filterOptions.enabled = false;
                app.columnsCall['2'].filterOptions.enabled = false;
                app.columnsCall['0'].hidden = true;
                app.columnsCall['1'].hidden = true;
                app.columnsCall['2'].hidden = true;
                app.columnsCall['4'].hidden = true;
                app.columnsCall['8'].hidden = true;
            } else {
                app.columnsCall['5'].hidden = true;
            }
        },
        methods: {
            /*customPageChange(customCurrentPage) {
             },
             customPerPageChange() {
             },*/
            jumpToPageInCall: function (e) {
                let self = this;
                self.jumpToInputPageCall(self.jumpToPageCall)
            },
            changedValueCall: function (value) {
                /*console.log(value);*/
            },
            jumpToInputPageCall: function (pageNumber) {
                var self = this;
                var reg = /^\d+$/;
                if (pageNumber <= 0 || pageNumber == '') {
                    pageNumber = 1;
                } else if (pageNumber > self.pageNumberListCall()) {
                    pageNumber = self.pageNumberListCall();
                    if (pageNumber <= 0 || pageNumber == '') {
                        pageNumber = 1;
                    }
                } else if (!String(self.jumpToPageCall).match(reg)) {
                    pageNumber = 1;
                }
                self.onPerticularPageClickCall(pageNumber);
            },
            onPerticularPageClickCall: function (pageNumber) {
                var self = this;
                self.serverParamsCall.page = pageNumber;
                self.jumpToPageCall = pageNumber;
                /* Single Backend Call on page load start */
                if(self.firstLoadCall != 1 && self.jumpToPageCall != 1){
                    self.loadCalls();
                } else if(self.firstLoadCall == 1 && self.jumpToPageCall >=1) {
                    self.loadCalls();
                }
                /* Single Backend Call on page load end */
            },
            pageNumberListCall: function () {
                var self = this;
                var totalRecord = self.totalRecordsCall;
                var count = 0;
                for (var i = 0; totalRecord > 0; i++) {
                    totalRecord = totalRecord - self.serverParamsCall.perPage;
                    count++;
                }
                return count;
            },
            changedValueCallCustomPerPageCall: function () {
                var self = this;
                /* Single Backend Call on page load start */
                if(self.firstLoadCall != 1){
                    self.jumpToInputPageCall(self.serverParamsCall.page);
                    self.loadCalls();
                }
                /* Single Backend Call on page load end */
            },
            getPermissionsCall: function () {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/user/permission",
                    type: "POST",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        self.exportFilteredFlagCall = false;
                        if (data.status == 'success') {
                            self.cantAccessPageCall = false;
                            self.permissionsCall = data.content;
                            let current_build = window.localStorage.getItem("build_version");
                            let latest_build = data.build;
                            if (current_build != undefined && current_build == '') {
                                localStorage.setItem("build_version", data.build);
                            } else if (current_build != latest_build) {
                                localStorage.setItem("build_version", data.build);
                                location.reload(true);
                            }
                            if (self.permissionsCall.length > 0) {
                                for (var i = 0; i < self.permissionsCall.length; i++) {
                                    if (self.permissionsCall[i].name == 'can_see_calls_list') {
                                        self.cantAccessPageCall = true;
                                    }
                                }
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.cantAccessPageCall = false;
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            updateParamsCall(newProps) {
                this.serverParamsCall = Object.assign({}, this.serverParamsCall, newProps);
            },
            //
            onPageChangeCall(params) {
                this.updateParamsCall({page: params.currentPage});

                this.loadCalls();
            },
            //
            onPerPageChangeCall(params) {
                this.updateParamsCall({perPage: params.currentPerPage});
                this.totalRecordsCall = this.totalRecordsCall;
                this.loadCalls();
            },
            onColumnFilterCall(params) {
                this.updateParamsCall(params);
                {
                    field: ('user_first_name');
                    field: ('cusid');
                    field: ('subject');
                    field: ('notes');
                    field: ('call_date_time');
                    field: ('direction');
                    field: ('customer_id');
                    field : ('priority');
                    field : ('call_type');
                    field : ('customer_first_name');
                    field : ('created_first_name');
                    field : ('contact_first_name');
                }
                ;
                this.serverParamsCall.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(this.serverParamsCall));
                var filters = filtersPr.columnFilters;

                if (this.firstLoadCall == 1 || filters.user_first_name || filters.cusid || filters.subject || filters.notes || filters.call_date_time
                        || filters.direction || filters.customer_id || filters.priority || filters.call_type || filters.customer_first_name
                        || filters.created_first_name || filters.contact_first_name) {
                    this.filteredFlag = true;
                    this.loadCalls();
                }

            },
            selectionChangedCall() {

                var self = this;
                // console.log( this.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },

            allClickCall: function () {
                var self = this;
                self.messageCall = 'all';
                self.loadCalls();
            },
            myClickCall: function () {
                var self = this;
                self.messageCall = 'my';
                self.serverParamsCall.page = 1;
                self.jumpToPageCall = 1;
                self.loadCalls();
            },
            normalClickCall: function () {
                var self = this;
                self.callType = 'normal';
                self.serverParamsCall.page = 1;
                self.jumpToPageCall = 1;
                self.loadCalls();
            },
            dunningClickCall: function () {
                var self = this;
                self.callType = 'dunning';
                self.serverParamsCall.page = 1;
                self.jumpToPageCall = 1;
                self.loadCalls();
            },        
            onSortChangeCall(params) {
                /*console.log(JSON.stringify(params));*/
                this.updateParamsCall({
                    sort: {
                        type: params.sortType,
                        field: this.columnsCall[params.columnIndex].field,
                        /*type: params[0].type,
                         field: params[0].field,*/
                    },
                });
                this.loadCalls();
            },
            loadCalls: function () {
                var self = this;
                self.serverParamsCall.setCurrentPage = self.serverParamsCall.page;
                if (self.messageCall == 'my') {
                    self.toggleButtons(self.messageCall, 'btn_my_call', 'btn_all_call');
                } else {
                    self.toggleButtons(self.messageCall, 'btn_all_call', 'btn_my_call');
                }
                if (self.callType == 'normal') {
                    self.toggleButtonsCall(self.callType, 'btn_normal_call', 'btn_dunning_call');
                } else {
                    self.toggleButtonsCall(self.callType, 'btn_dunning_call', 'btn_normal_call');
                }
                if (self.callPageData.cus_id > 0) {
                    var fields = {
                        page: self.serverParamsCall.page,
                        perPage: self.serverParamsCall.perPage,
                        filters: self.serverParamsCall.columnFilters,
                        messageData: self.messageCall,
                        callType: self.callType,
                        sort: self.serverParamsCall.sort,
                        // filtered:self.filteredFlag,
                        exportFiltered: self.exportFilteredFlagCall,
                        custid: self.callPageData.cus_id
                    };
                    self.storeFilters('menucallscustomer', self.serverParamsCall, false);
                } else {
                    var fields = {
                        page: self.serverParamsCall.page,
                        perPage: self.serverParamsCall.perPage,
                        filters: self.serverParamsCall.columnFilters,
                        messageData: self.messageCall,
                        callType: self.callType,
                        sort: self.serverParamsCall.sort,
                        // filtered:self.filteredFlag,
                        exportFiltered: self.exportFilteredFlagCall,
                    };
                    self.storeFilters('menucalls', self.serverParamsCall, false);
                }
                this.firstLoadCall = 1;
                self.showLoader();
                $.ajax({
                    url: process.env.ROOT_API + "/listcall",
                    type: "GET",
                    data: fields,
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        self.exportFilteredFlagCall = false;
                        if (data.message == 'success' || data.message == 'error') {
                            self.rowsCall = data.content.row;
                            self.totalRecordsCall = data.content.totalRecords;
                            self.showHidePagination("callsTable", self.totalRecordsCall);
                            self.filteredFlag = false;
                            self.jumpToPageCall = self.serverParamsCall.page;
                        }
                        if (data.message == "success export") {
                            //console.log(data.content.web);
                            $('#exportCall').html('<i class="fa fa-cloud-download" aria-hidden="true"></i>');
                            $('#exportCall').prop("disabled", false);
                            self.downloadFile(data.content.web);
                            // location.href = data.content.web;
                        }
                        self.paginationDisplayRowsCall = self.getRecords(self.serverParamsCall.page, self.serverParamsCall.perPage, self.totalRecordsCall);
                        self.hideLoader();
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }


                            self.error = jqXHR.responseJSON.message;
                        }
                        self.hideLoader();
                    }

                });
            },

            addCall() {
                var self = this;
                self.$router.push("/calls/create/" + self.callPageData.cus_id)
            },

            onDeleteClickCall() {
                //console.log("selected rows", this.$refs['listCallTable'].selectedRows)
                var self = this;
                var data = self.$refs['listCallTable'].selectedRows;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['listCallTable'].selectedRows[i].id)
                }
//                if (confirm('Are you sure that you want to delete this Calls! ')) {
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.value) {
                        Swal.fire(
                                'Deleted!',
                                'Your file has been deleted.',
                                'success'
                                )
                        $.ajax({
                            url: process.env.ROOT_API + "/call/delete",
                            type: "POST",
                            data: 'ids=' + use,
                            headers: {
                                'Accept': 'application/json',
                                "Access-Control-Allow-Origin": '*',
                                "Authorization": "Bearer " + localStorage.getItem("api_token"),
                                'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                                "Cache-Control": "no-cache"
                            },
                            dataType: 'json',
                            success: function (data) {
                                self.rowsCall = data.content.row;
                                if (data.code == '200') {
                                    // alert("Hii");
                                    self.rowsCall = data.content.row;
                                    self.totalRecordsCall = data.content.totalRecords;
                                    self.loadCalls();
                                }
                            },
                            error: function (jqXHR, exception) {
                                if (jqXHR.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (jqXHR.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem('user_obj');
                                        localStorage.removeItem('api_token');
                                        //EventBus.$emit("logged-in", true, "", "");
                                        self.$router.push("/login");
                                    }

                                    self.error = jqXHR.responseJSON.message;
                                }
                            }
                        });
                    }
                })

            },
            importCalls(e) {
                var self = this;
                $(e.target).html('');
                $(e.target).html('Importing...');
                $(e.target).prop("disabled", true);
                var formData = new FormData();
                for (var i = 0; i < self.filesCall.length; i++) {
                    let file = self.filesCall[0];
                    //console.log(file);
                    formData.append('excl_file', file);
                }
                //console.log(formData);
                $.ajax({
                    url: process.env.ROOT_API + "/call/import",
                    type: "POST",
                    data: formData,
                    processData: false,
                    contentType: false,
                    dataType: 'json',
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    success: function (data) {

                        if (data.status == "success") {
                            $("#errorMsg").html('');
                            $(e.target).html('');
                            $(e.target).html('Import');
                            $(e.target).prop("disabled", false);
                            /*$("#errorMsg").html(data.message);*/
                            self.loadCalls();
                            self.hideModelCall();
                            var messageType = 'success';
                            var messageTitle = 'Success';
                            if (data.import > 0) {
                                messageType = 'success';
                                messageTitle = 'Success';
                            } else {
                                messageType = 'info';
                                messageTitle = 'Warning';
                            }
                            Swal.fire({
                                type: messageType,
                                title: messageTitle,
                                html: data.message + '<br>' + data.messageSkipRecords,
                                showConfirmButton: true,
                            });
                        } else {
                            //console.log("hello");
                            $(e.target).html('');
                            $(e.target).html('Import');
                            $(e.target).prop("disabled", false);
                            $("#errorMsg").html(data.message);
                            if (data.content.length > 0) {
                                var err = "";
                                for (var i = 0; i < data.content.length; i++) {
                                    err += data.content[i] + "<br>";
                                }
                                $("#errorMsg").html(err);
                                //console.log(data.content[i]);
                            }
                        }

                    },
                    error: function (jqXHR, exception) {
                        $(e.target).html('');
                        $(e.target).html('Import');
                        $(e.target).prop("disabled", false);
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }

                            self.errorMsg = jqXHR.responseJSON.message;
                        }
                    }
                });
                // self.$router.push("/addtask");
                //self.$router.push("/task/create");
            },
            hideModelCall() {
                $('#callImportModal').modal('hide');
                return false;
            },
            handleFilesUploadCall: function () {
                /*
                 Get the uploaded files from the input.
                 */
                var self = this;
                let uploadedFiles = "";
                uploadedFiles = self.$refs.filesCall.files;
                //console.log(uploadedFiles);
                /*
                 Assign the uploaded file to the files array
                 */
                /*this.filesCall.pop();*/
                for (var i = 0; i < uploadedFiles.length; i++) {
                    self.filesCall = [uploadedFiles[i]];
                }
                /*this.getImagePreviews();*/
            },
            exportCalls(e) {
                var self = this;
                self.exportFilteredFlagCall = true;
                //console.log(self.exportFilteredFlagCall);
                // console.log(self.filteredFlag);
                if (self.exportFilteredFlagCall == true) {
                    //console.log("True");
                    self.loadCalls();
                } else {
                    //console.log("False");
                    //change button 
                    $(e.target).html('<i class="fa fa-cloud-download" aria-hidden="true"></i>...');
                    $(e.target).prop("disabled", true);
                    $.ajax({
                        url: process.env.ROOT_API + "/call/export",
                        type: "GET",
                        data: {type: 'xlsx'},
                        //processData: false,
                        //contentType: false,
                        dataType: 'json',
                        headers: {
                            'Accept': 'application/json',
                            "Access-Control-Allow-Origin": '*',
                            "Authorization": "Bearer " + localStorage.getItem("api_token"),
                            'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                            "Cache-Control": "no-cache"
                        },
                        success: function (data) {
                            if (data.status == "success") {
                                self.downloadFile(data.content.web);
                                // location.href = data.content.web;
                                /*$("#downloadButton").attr("href", data.content.web);
                                 $('#CallsExportModel').modal('show');*/
                                $(e.target).html('<i class="fa fa-cloud-download" aria-hidden="true"></i>');
                                $(e.target).prop("disabled", false);
                                // self.filteredFlag = false;
                                // self.exportFilteredFlagCall = false;
                                //alert('success');
                                /*alert(data.message);*/
                                /*$("#errorMsg").html(data.message);*/
                            } else {
                                $("#errorMsg").html(data.message);
                                if (data.content.length > 0) {
                                    var err = "";
                                    for (var i = 0; i < data.content.length; i++) {
                                        err += data.content[i] + "<br>";
                                    }
                                    $("#errorMsg").html(err);
                                }
                            }

                        },
                        error: function (jqXHR, exception) {
                            if (jqXHR.status == 0) {
                                self.errorMsg = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (jqXHR.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem('user_obj');
                                    localStorage.removeItem('api_token');
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }

                                self.errorMsg = jqXHR.responseJSON.message;
                            }
                        }
                    });
                }
                // self.loadTask();
            }
        }
    };
</script>
<style>
    .vgt-checkbox-col input {
        opacity: 1 !important;
        position: static !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/callsAndEmails/ListCallsComponent.vue